import Vue from "vue";
import App from "./App.vue";
import router from "./router/index";
import Normalize from "normalize.css";
import VueFire from "vuefire";
import axios from "axios";
import VueAnalytics from "vue-analytics";
import store from "../src/store";
import Toasted from "vue-toasted";
import Icon from "vue-awesome/components/Icon";
import "./assets/style.css";

Vue.config.productionTip = false;
Vue.use(Normalize);
Vue.use(VueFire);
// Vue.component('icon', Icon)

Vue.component("v-icon", Icon);

/*
Vue.use(Toasted, {
  position: 'bottom-center',
  className: ['toasted'],
  theme: 'none',
  duration: 3000
});
*/
Vue.use(Toasted);
Vue.toasted.register(
  "positiveToast",
  (payload) => {
    if (!payload.message) {
      return "NO TOAST MESSAGE SPECIFIED";
    }
    return payload.message;
  },
  {
    theme: "none",
    duration: 4000,
    position: "bottom-center",
    className: ["positiveToastClass"],
    singleton: true,
    fullWidth: true,
  }
);

const global = Vue.prototype;

global.$http = axios;

if (process.env.VUE_APP_DEPLOYMENT_TYPE == "production") {
  Vue.use(VueAnalytics, {
    id: "UA-121198315-1",
    router,
    autoTracking: {
      pageviewOnLoad: false,
    },
  });
}

global.$hardcodedPath = process.env.VUE_APP_PATH;

window.app = new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");

